import * as AT from './actionTypes'

export type SetResetCodeActionType = {
  payload: { readonly code: string }
  type: typeof AT.SET_RESET_CODE
}

export type SubmitForgotPasswordActionType = {
  type: typeof AT.SUBMIT
}

export type SubmitResetActionType = {
  type: typeof AT.SUBMIT_RESET
}

export type ForgotPasswordActionType =
  | SetResetCodeActionType
  | SubmitForgotPasswordActionType
  | SubmitResetActionType

const setResetCode = (code: string): ForgotPasswordActionType => ({
  payload: { code },
  type: AT.SET_RESET_CODE
})

const submit = (): ForgotPasswordActionType => ({
  type: AT.SUBMIT
})

const submitReset = (): ForgotPasswordActionType => ({
  type: AT.SUBMIT_RESET
})

export default { setResetCode, submit, submitReset }
